import axios from "axios";

let urlParams = new URLSearchParams(window.location.search);
let openerHost = urlParams.get('openerHost');
export let apiPath = "https://" + openerHost + "/v1";

// TODO: Add security here ^

// Default Axios config
export default axios.create({
    baseURL: apiPath,
    responseType: "json",
    crossDomain: true,
    withCredentials: true,
    // Bound every request so a stalled backend surfaces as an error
    // instead of leaving the UI waiting forever.
    timeout: 120000,
});